import { Typography } from "@mui/material";
import { toStartOfDay } from "@root/utils/date/toStartOfDay";
import { useI18nContext } from "@root/utils/organisation";
import { DateInputV2 } from "@styleguide";
import { useModalOfferContext } from "../../../context";

interface InterviewProps {
  label?: string;
  showTypography?: boolean;
}

export const Interview = ({ label = "Date*", showTypography = true }: InterviewProps = {}) => {
  const { apply, setApply, errors } = useModalOfferContext();
  const { timeZone } = useI18nContext();
  return (
    <>
      {showTypography && <Typography variant="body1">Merci d&apos;indiquer la date de l&apos;entretien :</Typography>}
      <DateInputV2
        timeZone={timeZone}
        label={label}
        value={apply.itwDate || undefined}
        onChange={(date) => {
          if (date && date.toString() !== "Invalid Date") {
            setApply((apply) => ({ ...apply, itwDate: toStartOfDay(date, timeZone) }));
          }
        }}
        TextFieldProps={{
          id: "input-interview-date",
          size: "small",
          placeholder: "Saisissez une date*",
          error: !!errors.itwDate,
        }}
      />
    </>
  );
};
